// extracted by mini-css-extract-plugin
export var buttonClose = "gallery-modal-module--button-close--9f3eb";
export var container = "gallery-modal-module--container--46f5f";
export var dot = "gallery-modal-module--dot--72c51";
export var dots = "gallery-modal-module--dots--0f274";
export var hiddenCloseButton = "gallery-modal-module--hidden-close-button--88646";
export var img = "gallery-modal-module--img--c216d";
export var next = "gallery-modal-module--next--e4059";
export var prev = "gallery-modal-module--prev--1cec8";
export var ratioBox = "gallery-modal-module--ratio-box--d9595";
export var slide = "gallery-modal-module--slide--7cd48";
export var slider = "gallery-modal-module--slider--2f8f4";
export var sliderContainer = "gallery-modal-module--slider-container--a9c8b";